import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import globalSelectors from '../../../../store/global-selectors';
import { ALL_STORES_STORE_GUID } from '../../../../store/returns/returns.helpers';
import { useEnhancedReturnsContext } from '../grids/enhanced-returns-context';
import { RETURNS_GRID_RELOAD } from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';

import { EditEnhancedReturnsColumnsButton } from '../edit-columns-button';
import { messages } from '../messages';

import styles from '../styles.module.less';

type SSRHeaderProps = {
  storeGuid?: string;
};

export const SSRHeader = ({ storeGuid = '' }: SSRHeaderProps) => {
  const intl = useIntl();
  const { onReload } = useEnhancedReturnsContext();
  const stores = useSelector(globalSelectors.selectSellerActiveStores);

  const storeName =
    storeGuid === ALL_STORES_STORE_GUID
      ? intl.formatMessage(messages.allStores)
      : // oxlint-disable-next-line @typescript-eslint/no-explicit-any
        (stores.find((s: any) => s.storeGuid === storeGuid)?.name ?? intl.formatMessage(messages.unknownStore));

  const handleReload = useCallback(() => {
    Segment.trackEvent(RETURNS_GRID_RELOAD, {
      type: RETURNS_GRID_RELOAD,
      storeGuid,
    });

    onReload();
  }, [onReload, storeGuid]);

  return (
    <>
      <div className={styles['name-and-reload']}>
        <Text textType={TextType.H3} value={storeName} />
        <Button onClick={handleReload} theme='ghost'>
          <FontAwesomeIcon icon={faRedo} />
          <Text textType={TextType.Caption} value={messages.reload} />
        </Button>
      </div>
      <div className={styles['header-actions']}>
        <EditEnhancedReturnsColumnsButton />
      </div>
    </>
  );
};
